import { render, staticRenderFns } from "./VeWidthUnitToggle.vue?vue&type=template&id=2bc2d9a2&scoped=true"
import script from "./VeWidthUnitToggle.vue?vue&type=script&lang=js"
export * from "./VeWidthUnitToggle.vue?vue&type=script&lang=js"
import style0 from "./VeWidthUnitToggle.vue?vue&type=style&index=0&id=2bc2d9a2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc2d9a2",
  null
  
)

export default component.exports